import { CircleCheck, CircleDashed, CircleX, Hand } from 'lucide-react';

/** The five states of a piece of work, their words and their shape. Running draws a spinner instead of an icon. */
export const EXECUTION_STATES = {
  queued: { label: 'Queued', icon: CircleDashed },
  running: { label: 'Running', icon: null },
  waiting: { label: 'Waiting for you', icon: Hand },
  done: { label: 'Done', icon: CircleCheck },
  failed: { label: 'Failed', icon: CircleX }
};
